import { render } from "./SearchRobots.vue?vue&type=template&id=675b5722&scoped=true"
import script from "./SearchRobots.vue?vue&type=script&lang=js"
export * from "./SearchRobots.vue?vue&type=script&lang=js"

import "./SearchRobots.vue?vue&type=style&index=0&id=675b5722&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-675b5722"]])

export default __exports__